/** Stored value → label for parts material category */
export const MATERIAL_CATEGORY_OPTIONS: { value: string; label: string }[] = [
  { value: "", label: "Select" },
  { value: "metals", label: "Metals" },
  { value: "polymers", label: "Polymers" },
  { value: "composites", label: "Composites" },
  { value: "ceramics", label: "Ceramics" },
  { value: "elastomers", label: "Elastomers" },
  { value: "other", label: "Other" },
];

export function materialCategoryLabel(value: string | null | undefined): string {
  if (!value) return "";
  const o = MATERIAL_CATEGORY_OPTIONS.find((x) => x.value === value);
  return o?.label ?? value;
}
